module.exports = "https://bin.bnbstatic.com/_next/static/images/error-461c33a11e229c6e7b50b7fefbeccb8a.svg";